import React from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col } from "react-bootstrap";
import { TextInput } from "../../../../ui";

export const Bank = () => {
  const { register } = useFormContext();
  return (
    <div className="custom-box">
      <Row>
        <h1 className="my-4">اطلاعات سایت و تسویه بانکی</h1>
      </Row>
      <Row>
        <Col md={3} sm={6}>
          <TextInput
            registration={register("website")}
            placeholder={" آدرس اینترنتی وب سایت خود را وارد کنید"}
            label={"آدرس اینترنتی وب سایت"}
            isRequired
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} sm={6}>
          <TextInput
            registration={register("shaba")}
            placeholder={"شماره شبا خود را وارد کنید"}
            label={"شماره شبا"}
            isRequired
          />
        </Col>
      </Row>
    </div>
  );
};
